module.exports = __webpack_public_path__ + "static/media/ada_logo.f7aa1984.svg";